export type DatePickerValue = Date | string | number | null | undefined

const isValidDate = (value: Date): boolean => Number.isFinite(value.getTime())

export const parseDatePickerValue = (value: DatePickerValue): Date | null => {
  if (value == null || value === '') return null

  if (value instanceof Date) {
    return isValidDate(value) ? new Date(value.getTime()) : null
  }

  if (typeof value === 'number') {
    const parsed = new Date(value)
    return isValidDate(parsed) ? parsed : null
  }

  const trimmed = value.trim()
  if (/^\d+$/.test(trimmed)) {
    const parsed = new Date(Number(trimmed))
    return isValidDate(parsed) ? parsed : null
  }

  // A date-only GraphQL value represents a calendar date, not UTC midnight.
  // Constructing it locally prevents it shifting a day in negative timezones.
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed)
  if (dateOnly) {
    const parsed = new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    return isValidDate(parsed) ? parsed : null
  }

  const parsed = new Date(trimmed)
  return isValidDate(parsed) ? parsed : null
}

export const serializeLocalDate = (value: Date, endOfDay = false): string => {
  const hours = endOfDay ? 23 : 0
  const minutes = endOfDay ? 59 : 0
  const seconds = endOfDay ? 59 : 0
  const milliseconds = endOfDay ? 999 : 0
  const normalized = new Date(
    value.getFullYear(),
    value.getMonth(),
    value.getDate(),
    hours,
    minutes,
    seconds,
    milliseconds,
  )

  if (!isValidDate(normalized)) throw new Error('Cannot serialize an invalid date')
  return normalized.toISOString()
}
